import MediaItem from 'src/components/MediaGallery/MediaItem';
import { useMemo } from 'react';
import GalleryOverlay from 'src/components/MediaGallery/GalleryOverlay';

const MediaGallery = ({ media = [], onItemClick = () => {} }) => {
  const primaryMedia = useMemo(() => media.find((media) => media.primary) || media[0], [media]);
  const otherMedia = useMemo(
    () => media.filter((media) => media !== primaryMedia),
    [media, primaryMedia]
  );

  if (media.length === 1) {
    const isSinglePdf = primaryMedia.type === 'pdf';
    return (
      <MediaItem
        onClick={() => onItemClick(0)}
        src={primaryMedia.src}
        type={primaryMedia.type}
        thumbnail={primaryMedia.thumbnail}
        caption={primaryMedia.caption}
        isSinglePdf={isSinglePdf}
      />
    );
  }

  return (
    <div className="flex flex-col sm:flex-row gap-1 max-h-[500px] max-w-[1000px] overflow-hidden">
      <div className="w-full sm:w-2/3 overflow-hidden ">
        <MediaItem
          onClick={() => onItemClick(0)}
          src={primaryMedia.src}
          type={primaryMedia.type}
          thumbnail={primaryMedia.thumbnail}
          caption={primaryMedia.caption}
        />
      </div>

      <div className="w-full sm:w-1/3 flex flex-wrap gap-1 overflow-hidden">
        {otherMedia.slice(0, 2).map((media, index) => {
          const applyOverlay = otherMedia.length - 2 > 0 && index === 1;

          return (
            <div
              className="relative w-[49%] sm:w-full md:h-[49%] min-h-[50px] min-w-[50px]"
              key={index}
            >
              {applyOverlay ? (
                <GalleryOverlay count={otherMedia.length - 2}>
                  <MediaItem
                    onClick={() => onItemClick(index + 1)}
                    src={media.src}
                    type={media.type}
                    thumbnail={media.thumbnail}
                    caption={media.caption}
                  />
                </GalleryOverlay>
              ) : (
                <MediaItem
                  onClick={() => onItemClick(index + 1)}
                  src={media.src}
                  count={otherMedia.length - 1}
                  type={media.type}
                  thumbnail={media.thumbnail}
                  caption={media.caption}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MediaGallery;
